/**
 * Traductions des mécaniques de jeu, un fichier par mécanique et par langue.
 *
 * Elles ne vivent pas dans `locales/fr.json` pour une raison très concrète :
 * seize mécaniques sont développées en parallèle, et un fichier de traduction
 * unique en fait un point de contention où chaque lot entre en conflit avec les
 * quinze autres. Un fichier par mécanique supprime le problème à la racine.
 *
 * L'agrégation est automatique : déposer `locales/games/{fr,en}/ma-mecanique.json`
 * suffit, il n'y a aucun registre à tenir à jour. Le nom du fichier devient la
 * clé, qui doit être l'identifiant exact de la mécanique côté serveur
 * (`GameId`), et les chaînes sont lues sous `practice.games.<identifiant>`.
 *
 * La parité entre les deux langues est vérifiée par
 * `__tests__/translations.test.ts` : un fichier ajouté d'un seul côté, ou une
 * clé oubliée, fait rougir la suite.
 */

type ArbreTraduction = Record<string, unknown>

function agreger(modules: Record<string, unknown>): ArbreTraduction {
  const resultat: ArbreTraduction = {}

  for (const [chemin, module] of Object.entries(modules)) {
    const identifiant = chemin.split('/').pop()?.replace(/\.json$/, '')
    if (!identifiant) continue
    resultat[identifiant] = (module as { default: ArbreTraduction }).default
  }

  return resultat
}

export const jeuxFr = agreger(
  import.meta.glob('./locales/games/fr/*.json', { eager: true }),
)

export const jeuxEn = agreger(
  import.meta.glob('./locales/games/en/*.json', { eager: true }),
)
